// src/store/index.js

import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import conversationReducer from './conversationSlice';
import dashboardReducer from './dashboardSlice';
import snackbarReducer from './snackbarSlice';
import posthogMiddleware from './posthogMiddleware';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    conversation: conversationReducer,
    dashboard: dashboardReducer,
    snackbar: snackbarReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(posthogMiddleware),
});
